import { render, staticRenderFns } from "./TaskAssignee.vue?vue&type=template&id=a34dc3aa"
import script from "./TaskAssignee.vue?vue&type=script&lang=js"
export * from "./TaskAssignee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports